import { render, staticRenderFns } from "./SignaturesList.vue?vue&type=template&id=a70f81ce&scoped=true"
import script from "./SignaturesList.vue?vue&type=script&lang=js"
export * from "./SignaturesList.vue?vue&type=script&lang=js"
import style0 from "./SignaturesList.vue?vue&type=style&index=0&id=a70f81ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70f81ce",
  null
  
)

export default component.exports